module.exports = __webpack_public_path__ + "img/avatar-0a.59b0d91c.jpg";